
function MenuToggles() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles. <br/>
    /// It does
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.managementHeight = 800; //default height
    this.date = getCurrentTimestamp();
}

MenuToggles.prototype = new vcTemplate();

MenuToggles.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler and sets some heights. 
    /// </summary>
    var me = this;
    var menuHeight = 90;
    try {
        if (me.error) { return false; }

        if (me.deviceType ===1) {menuHeight = 250}

        me.showInfo("", "", false);
        //optionally we fix the content height
       
        if (me.fixedHeight) {
            me.visual.find("#div-content").height(parseInt(me.height - me.visual.find("#div-menu").outerHeight() - me.visual.find("#div-info-content").outerHeight()-10));
            if (me.useDatePicker) {
                me.visual.find("#div-content").height(parseInt(me.visual.find("#div-content").outerHeight() - menuHeight));
            }        
        }
       
        //we fix and adopt them management height (only if we got a height at all)
        if (me.height > 0) {
            if (parseInt(me.height - me.visual.find("#div-menu").height()) < me.managementHeight) {
                me.managementHeight = parseInt(me.height - me.visual.find("#div-menu").height());
            }
        }
       
        //if (me.useDatePicker) {
        //    me.visual.find(".vc-cal").vcDateBox(
        //        { mode: me.dateMode, interval: me.dateInterval, langID: me.userLangidForCulture,
        //            callback: function (obj) {
        //                me.changeDate(obj);
        //            }
        //        }
        //    );
        //}

        me.visual.find("#div-menu .button-toggle").button().off("click").on("click", function () {
            me.loadContent(parseInt($(this).data("index")));
        });
        me.loadContent(0);
        me.initContent();
        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

MenuToggles.prototype.initContent = function () {
    /// <summary>
    /// This function inits the menu click handler and sets some heights. 
    /// </summary>
    var me = this;
    try {
      
        me.loadContent(0);

        return true;
    } catch (ex) { me.writeError('initContent', ex); return false }

}


// ReSharper disable once UnusedParameter
MenuToggles.prototype.changeDate = function (obj) {}

MenuToggles.prototype.toggleButtons = function (index) {
    /// <summary>
    /// This function switches the active buttons. 
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }

        me.visual.find("#div-menu .button-toggle").removeClass("button-toggle-active");
        me.visual.find("#div-menu .button-toggle[data-index=" + index + "]").addClass("button-toggle-active");

        return true;
    } catch (ex) { me.writeError('toggleButtons', ex); return false }

}

MenuToggles.prototype.prepareContent = function () {
    /// <summary>
    /// This function switches between the contents and generates a random container for the visuals 
    /// </summary>
    var me = this;
    var container;
    try {
       
        container = me.getRandomIDContainerObj("div-content-", true);
        me.visual.find("#div-content").html(container.obj);

        me.visual.find("#div-management").hide();
        me.visual.find("#div-content-frame").show();

        me.visual.find("#div-info-content").show();
        me.visual.find("#div-info-management").hide();
        
       
        return container;
    } catch (ex) { me.writeError('showContent', ex);return null }

}

MenuToggles.prototype.prepareManagement = function (h) {
    /// <summary>
    /// This function switches between the contents and generates a random container for the visuals  
    /// </summary>
    var me = this;
    var container;
    try {

        container = me.getRandomIDContainerObj("div-management-", true);
        me.visual.find("#div-management").html(container.obj);


        me.visual.find(" #div-content-frame").hide();

        // if a different height is set for the div-management, we use the desired height
        if(h)
            me.visual.find("#div-management").height(h).show();
        else
            me.visual.find("#div-management").height(me.managementHeight).show();

        me.visual.find("#div-info-content").hide();
        me.visual.find("#div-info-management").show();


        return container;
    } catch (ex) { me.writeError('showMagement', ex);return null }

}


function MenuTogglesAlarm() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Alarm <br/>
    /// It does
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesAlarm.prototype = new MenuToggles();

MenuTogglesAlarm.prototype.loadContent = function (index) {
    /// <summary>
    /// This function loads the contents based on the selected button
    /// </summary>
    var me = this;
    var content;
    var container;
    try {
        if (me.error) { return false; }

        if (index === 0) {
            content = me.visual.find("#div-content");
            container = me.prepareContent();
           
            me.vcVisual.addVisualBaseByName(container.prefix, "VISUAL_ALARMHISTORY", container.random, getCurrentTimestamp(), parseInt(content.height(), 10), parseInt(content.width(), 10), JSON.stringify({ 'loggerid': me.blid, 'FixedContentHeight': me.fixedHeight }), "", me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                container = me.prepareManagement();
               
                container.obj.height(me.height);
                container.obj.EventOverview({ invokeType: "addVisualBase", parameter: { LoggerId: me.blid } });
                //me.vcVisual.addVisualBaseByName(container.prefix, 'VISUAL_FORM_ALARMRULES', container.random, getCurrentTimestamp(), parseInt(content.height() - 50, 10), parseInt(content.width(), 10), "true", "", me.deviceType);
            } 
        }

        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}


function MenuTogglesActivity() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Activity <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesActivity.prototype = new MenuToggles();

MenuTogglesActivity.prototype.changeDate = function (obj) {
    /// <summary>
    /// This function handles the callback of the vcDate
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.date = obj.returnDates.from;
        me.loadContent(0);

        return true;
    } catch (ex) { me.writeError('changeDate', ex); return false }

}

MenuTogglesActivity.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }

        // we set the content height for the activities again and use it for the div-content and div-management and the new activity widget height
        me.visual.find("#div-content").height(parseInt(me.height - me.visual.find("#div-menu").outerHeight() - 10));
        var hWidget = me.visual.find("#div-content").height();

        if (index === 0) {
            content = me.visual.find("#div-content");           
            container = me.prepareContent();

            var bdid = "bdid";
            if (me.deviceID > -1) bdid = me.deviceID;            

            //TODO: MKU - CHANGE ACTIVITIES HERE - readonly, showOverview = false, given blid, all user, edit = false, isSeen = true, timerange=year
            //see MenuToggleAlarm - how to handle VcWidgetV4
            container.obj.height(hWidget);
            container.obj.Activities({ invokeType: "addVisualBase", parameter: { UserId: -1, Editable: false, ShowOverview: false, StartWithOverview: false, isSeen: true, BillingMode: false, TimeRange: 5 } });

            //me.vcVisual.addVisualBaseByName(container.prefix, "WIDGET_ACTIVITY", container.random, me.date, parseInt(content.height(), 10) - 25, parseInt(content.width(), 10), "23:59," + bdid + ",false,5,10", "false," + me.fixedHeight.toString() + "," + me.blid, me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                container = me.prepareManagement(hWidget - 35); // we set the height to the same height of content
                //TODO: MKU - CHANGE ACTIVITIES HERE -  showOverview = true, current user, timerange=month

                container.obj.height(hWidget - 35);
                container.obj.Activities({ invokeType: "addVisualBase", parameter: { Editable: true, ShowOverview: true, StartWithOverview: false, isSeen: false, BillingMode: false, TimeRange: 3 } });


                //me.vcVisual.addVisualByName(container.prefix, 'VISUAL_FORM_ACTIVITY',container.random, getCurrentTimestamp(), parseInt(content.height()-50, 10), parseInt(content.width(), 10), "true,-1," + me.blid, "", me.deviceType);
            }
        }

        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}

function MenuTogglesEvent() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Events <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesEvent.prototype = new MenuToggles();

MenuTogglesEvent.prototype.changeDate = function (obj) {
    /// <summary>
    /// This function handles the callback of the vcDate
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.date = obj.returnDates.from;

        if (me.fixedHeight===false) {
           me.visual.find("#div-content").css("min-height", "1000px");}

        me.loadContent(0);

        return true;
    } catch (ex) { me.writeError('changeDate', ex); return false }

}

MenuTogglesEvent.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }

        if (index === 0) {
           
            content = me.visual.find("#div-content");
            container = me.prepareContent();
            me.vcVisual.addVisualBaseByName(container.prefix, "VISUAL_INTERVENTION_LIST", container.random, me.date, parseInt(content.height(), 10), parseInt(content.width(), 10), JSON.stringify({'loggerid': me.blid, 'FixedContentHeight':me.fixedHeight}), "", me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                content.css("overflow", "hidden");
                container = me.prepareManagement();
                me.vcVisual.setShowFullscreen(false);
               
                me.vcVisual.addVisualByName(container.prefix, 'VISUAL_FORM_INTERVENTION', container.random, getCurrentTimestamp(), parseInt(content.height() - 55, 10), parseInt(content.width() - 8, 10), "true,-1," + me.blid, "", me.deviceType);

            }
        }
        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}



function MenuTogglesTicket() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Ticket <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 23.10.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 23.10.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesTicket.prototype = new MenuToggles();



MenuTogglesTicket.prototype.initContent = function () {
    /// <summary>
    /// This function inits the menu click handler and sets some heights. 
    /// </summary>
    var me = this;
    try {

        me.managementHeight = parseInt(me.height - me.visual.find("#div-menu").height());
        me.ticketContentHeight = me.managementHeight;
        if (me.isStaff || me.hasEditRight) {
            me.loadContent(1);
        } else {
            me.loadContent(0);
        }
        return true;
    } catch (ex) { me.writeError('initContent', ex); return false }

}

MenuTogglesTicket.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }
      
        if (index === 0) {
         
            content = me.visual.find("#div-content");
            container = me.prepareContent();
            content.height(me.ticketContentHeight);
            container.obj.height(me.ticketContentHeight);
            container.obj.TicketList({ invokeType: "addVisualBase", parameter: { LoggerId: me.blid, "ReadOnlyMode": true, 'CurrentProjectOnly': true } });


        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                container = me.prepareManagement();
                container.obj.height(me.ticketContentHeight);
             
                container.obj.TicketList({ invokeType: "addVisualBase", parameter: { LoggerId: me.blid, "ReadOnlyMode": false, 'CurrentProjectOnly': true } });

            }
        }
        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}

function MenuTogglesVersion() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Version <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 21.7.2021<br />
    /// Copyright ©: EUDT GmbH 2021 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 21.7.2021                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesVersion.prototype = new MenuToggles();

MenuTogglesVersion.prototype.changeDate = function (obj) {
    /// <summary>
    /// This function handles the callback of the vcDate
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
     
        if (me.fixedHeight === false) {
            me.visual.find("#div-content").css("min-height", "1000px");
        }

        me.loadContent(0);

        return true;
    } catch (ex) { me.writeError('changeDate', ex); return false }

}

MenuTogglesVersion.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }

        if (index === 0) {

            content = me.visual.find("#div-content");
            container = me.prepareContent();
            me.vcVisual.addVisualBaseByName(container.prefix, "VISUAL_VERSION", container.random, me.date, parseInt(content.height(), 10), parseInt(content.width(), 10), "", "", me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                content.css("overflow", "hidden");
                container = me.prepareManagement();
                me.vcVisual.setShowFullscreen(false);

                me.vcVisual.addVisualBaseByName(container.prefix, 'VISUAL_FORM_VERSION', container.random, getCurrentTimestamp(), parseInt(content.height() - 55, 10), parseInt(content.width() - 8, 10), "true,-1," + me.blid, "", me.deviceType);

            }
        }
        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}



function MenuTogglesContacts() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Contacts <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 30.10.2024<br />
    /// Copyright ©: EUDT GmbH 2021 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 30.10.2024                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesContacts.prototype = new MenuToggles();


MenuTogglesContacts.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }

        if (index === 0) {

            content = me.visual.find("#div-content");
            container = me.prepareContent();
           
            me.vcVisual.addVisualContentByName(container.prefix, "WIDGET_PROJECT_CONTACTS", container.random, me.date, parseInt(content.height()-55, 10), parseInt(content.width(), 10), "", "{loggerid:" + me.blid + "}", me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                content.css("overflow", "hidden");
                container = me.prepareManagement();
                me.vcVisual.setShowFullscreen(false);
                me.vcVisual.addVisualBaseByName(container.prefix, 'WIDGET_PROJECT_CONTACT_MANAGER', container.random, getCurrentTimestamp(), parseInt(content.height() - 55, 10), parseInt(content.width() - 8, 10), "", JSON.stringify({ 'loggerid': me.blid }), me.deviceType);

            }
        }
        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}


function MenuTogglesTopo() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Menu.Toggles.Contacts <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 30.10.2024<br />
    /// Copyright ©: EUDT GmbH 2021 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 30.10.2024                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
MenuTogglesTopo.prototype = new MenuToggles();


MenuTogglesTopo.prototype.loadContent = function (index) {
    /// <summary>
    /// This function  loads the contents based on the selected button
    /// </summary>
    var me = this;
    var container;
    var content;
    try {
        if (me.error) { return false; }
        me.visual.find("#div-content").html("");
        if (index === 0) {

            content = me.visual.find("#div-content");
            container = me.prepareContent();
            //me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_SIGNAL_TOPOLOGY', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid }), JSON.stringify({ bsagid: -1, width: me.contentSize.w, height: me.contentSize.h }), 1);

            me.vcVisual.addVisualBaseByName(container.prefix, "VISUAL_SIGNAL_TOPOLOGY", container.random, me.date, parseInt(content.height(), 10), parseInt(content.width(), 10), JSON.stringify({ 'LoggerID': me.blid }), JSON.stringify({ bsagid: -1, width: parseInt(content.width(), 10), height: parseInt(content.height(), 10) }), me.deviceType);
        } else {
            if (index === 1) {
                content = me.visual.find("#div-management");
                content.css("overflow", "hidden");
                container = me.prepareManagement();
                me.vcVisual.setShowFullscreen(false);

                //me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_SIGNAL_DEPENDENCY', container.random, getCurrentTimestamp(), container.obj.height() - 14, me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }), "", 1);

                me.vcVisual.addVisualBaseByName(container.prefix, 'VISUAL_SIGNAL_DEPENDENCY', container.random, getCurrentTimestamp(), parseInt(content.height() - 55, 10), parseInt(content.width() - 8, 10), JSON.stringify({ LoggerID: me.blid }) , "", me.deviceType);

            }
        }
        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}

